module.exports = __webpack_public_path__ + "static/media/santander.20501178.svg";